__turbopack_context__.v({
  "banner": "GzlTechnologyBanner-module__IN2oWa__banner",
  "close": "GzlTechnologyBanner-module__IN2oWa__close",
  "compactMobile": "GzlTechnologyBanner-module__IN2oWa__compactMobile",
  "copy": "GzlTechnologyBanner-module__IN2oWa__copy",
  "cta": "GzlTechnologyBanner-module__IN2oWa__cta",
  "dialog": "GzlTechnologyBanner-module__IN2oWa__dialog",
  "dialogHeader": "GzlTechnologyBanner-module__IN2oWa__dialogHeader",
  "form": "GzlTechnologyBanner-module__IN2oWa__form",
  "label": "GzlTechnologyBanner-module__IN2oWa__label",
  "logo": "GzlTechnologyBanner-module__IN2oWa__logo",
  "quote": "GzlTechnologyBanner-module__IN2oWa__quote",
  "services": "GzlTechnologyBanner-module__IN2oWa__services",
  "shell": "GzlTechnologyBanner-module__IN2oWa__shell",
  "title": "GzlTechnologyBanner-module__IN2oWa__title",
  "visual": "GzlTechnologyBanner-module__IN2oWa__visual",
});
